import { render, staticRenderFns } from "./linkedproduct.vue?vue&type=template&id=29d7238c"
import script from "./linkedproduct.vue?vue&type=script&lang=ts"
export * from "./linkedproduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports